S.eventform = {

    config: {
        summary: 0,
        dtstart: 0,
        starttime: 0,
        endtime: 0,
        languageUid: null,
        email: null,
        eventLink: null,
    },
    elements: {
        $button: null,
    },

    init()
    {
        this.generateIcs();
        if (this.elements.$button.length)
        {
            $('html, body').scrollTop(this.elements.$button.position().top - ($(window).height() / 2) + 100);
        }
    },

    generateIcs()
    {
        const summary = this.config.summary;
        const dtstart = new Date(this.config.dtstart);
        let starttime = new Date(this.config.starttime);
        let endtime = new Date(this.config.endtime);
        const now = new Date($.now());

        starttime = new Date(starttime.setFullYear(dtstart.getFullYear(), dtstart.getMonth(), dtstart.getDate()));
        endtime = new Date(endtime.setFullYear(dtstart.getFullYear(), dtstart.getMonth(), dtstart.getDate()));

        this.elements.$button.on('click', () =>
        {
            this.download('giz-ina-event.ics',
                'BEGIN:VCALENDAR\n' +
        'PRODID:-//GIZ INA//nachhaltige-agrarlieferketten.org//DE\n' +
        'VERSION:2.0\n' +
        'CALSCALE:GREGORIAN\n' +
        'METHOD:PUBLISH\n' +
        'X-MS-OLK-FORCEINSPECTOROPEN:TRUE\n' +
        'BEGIN:VEVENT\n' +
        'CLASS:PUBLIC\n' +
        'CREATED:' + this.getEventTime(now) + '\n' +
        'DESCRIPTION:' + this.getDescription(starttime, endtime) + '\n' +
        'DTSTART;TZID=Europe/Berlin:' + this.getEventTime(starttime) + '\n' +
        'DTEND;TZID=Europe/Berlin:' + this.getEventTime(endtime) + '\n' +
        'LOCATION:Online\n' +
        'DTSTAMP:' + now.toISOString() + '\n' +
        'PRIORITY:5:\n' +
        'SUMMARY:' + summary + '\n' +
        'TRANSP:OPAQUE\n' +
        'UID:' + now.toISOString() + '-' + starttime.toISOString() + '-' + endtime.toISOString() + '\n' +
        'X-MICROSOFT-CDO-BUSYSTATUS:BUSY\n' +
        'X-MICROSOFT-CDO-IMPORTANCE:1\n' +
        'X-MICROSOFT-DISALLOW-COUNTER:FALSE\n' +
        'X-MS-OLK-AUTOFILLLOCATION:FALSE\n' +
        'X-MS-OLK-CONFTYPE:0\n' +
        'BEGIN:VALARM\n' +
        'TRIGGER:-PT15M\n' +
        'ACTION:DISPLAY\n' +
        'DESCRIPTION:Reminder\n' +
        'END:VALARM\n' +
        'END:VEVENT\n' +
        'END:VCALENDAR');
        });
    },

    getEventTime(time)
    {
        return time.getFullYear().toString() + ('0' + (time.getUTCMonth() + 1)).slice(-2) + ('0' + (time.getUTCDate())).slice(-2) + 'T' + ('0' + (time.getUTCHours())).slice(-2) + ('0' + (time.getUTCMinutes())).slice(-2) + ('0' + (time.getUTCSeconds())).slice(-2);
    },

    download(filename, text)
    {
        const element = document.createElement('a');

        element.setAttribute('target', '_self');
        element.setAttribute('href', 'data:text/calendar;charset=utf8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    },

    getDescription(start, end)
    {
        if (this.config.languageUid === 0)
        {
            return ('Vielen Dank für Ihr Interesse an der Veranstaltung „' +
        this.config.summary + '“ der GIZ.\\n Anbei finden Sie einen MS-Teams Einwahllink sowie einen Kalendereintrag für den ' + start.getUTCDate() + '/' + ('0' + (start.getUTCMonth() + 1)).slice(-2) + '/' + start.getUTCFullYear() + ' von ' + ('0' + (start.getUTCHours())).slice(-2) + ':' + ('0' + (start.getUTCMinutes())).slice(-2) + ' bis ' + ('0' + (end.getUTCHours())).slice(-2) + ':' + ('0' + (end.getUTCMinutes())).slice(-2) + ' Uhr. \\n Sollten Sie Fragen zu der Veranstaltung haben, können Sie sich jederzeit an uns wenden (' + this.config.email + ').\\nWir freuen uns auf Sie!\\n \\n \\n \\n' + this.config.eventLink);
        }

        return ('Thank you for your interest in the event "' +
      this.config.summary + '“ by the GIZ.\\n Enclosed you will find a MS-Teams dial-in link and a calendar entry for ' + start.getUTCDate() + '/' + ('0' + (start.getUTCMonth() + 1)).slice(-2) + '/' + start.getUTCFullYear() + ' from ' + ('0' + (start.getUTCHours())).slice(-2) + ':' + ('0' + (start.getUTCMinutes())).slice(-2) + ' to ' + ('0' + (end.getUTCHours())).slice(-2) + ':' + ('0' + (end.getUTCMinutes())).slice(-2) + ' . \\n If you have any questions about the event, you can contact us at any time (' + this.config.email + ').\\nWe look forward to you!\\n \\n \\n \\n' + this.config.eventLink);
    },
};
